const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEXP.test(email);
}

// Explains what is wrong with a single e-mail address, or returns null when it looks fine.
export function emailProblem(value: string): string | null {
  const email = value.trim();
  if (!email) return 'Skriv inn en e-postadresse.';
  if (splitEmails(email).filter((x) => x.includes('@')).length > 1) return 'Skriv inn bare én e-postadresse.';
  if (!email.includes('@')) return 'E-postadressen mangler @.';
  if (!isValidEmail(email)) return 'Dette ser ikke ut som en gyldig e-postadresse, f.eks. ola.nordmann@firma.no.';
  return null;
}

// Splits a pasted list on commas, semicolons, spaces and line breaks, dropping duplicates.
export function parseEmailList(value: string): string[] {
  const seen = new Set<string>();
  return splitEmails(value).filter((x) => {
    const key = x.toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

// Explains what is wrong with a list of e-mail addresses, or returns null when they all look fine.
export function emailListProblem(value: string): string | null {
  const emails = parseEmailList(value);
  if (emails.length === 0) return 'Skriv inn minst én e-postadresse.';
  const invalid = emails.filter((x) => !isValidEmail(x));
  if (invalid.length === 1) return `Dette ser ikke ut som en gyldig e-postadresse: ${invalid[0]}`;
  if (invalid.length > 1) return `Disse ser ikke ut som gyldige e-postadresser: ${invalid.join(', ')}`;
  return null;
}

function splitEmails(value: string): string[] {
  return value.split(/[\s,;]+/).filter(Boolean);
}
